import { createSlice } from '@reduxjs/toolkit';
import { OrderMessagesOnExpeditionBoxGridStateType } from 'src/types/orderMessagesOnExpeditionBoxGrid';

const initialState: OrderMessagesOnExpeditionBoxGridStateType = {
    data: null,
    loading: false,
    error: false,
};
export const orderMessagesOnExpeditionBoxGridSlice = createSlice({
    name: 'orderMessagesOnExpeditionBoxGrid',
    initialState,
    reducers: {
        getOrderMessagesOnExpeditionBoxGridFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getOrderMessagesOnExpeditionBoxGridFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getOrderMessagesOnExpeditionBoxGridFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getOrderMessagesOnExpeditionBoxGridFetch,
    getOrderMessagesOnExpeditionBoxGridFetchSuccess,
    getOrderMessagesOnExpeditionBoxGridFetchFailure,
} = orderMessagesOnExpeditionBoxGridSlice.actions;

export default orderMessagesOnExpeditionBoxGridSlice.reducer;
